import type { WebWidgetModel } from '@web/types';

import { ECartIconType, ESize, Widgets } from '@common/enums';
import { defaultWidgetPermission, defaultWidgetParams } from '@common/constants';

import { type ShopCartIconWidgetData } from '@web/widgets/shop-cart-icon/type/shop-cart-icon-widget.type';
import { ShopCartIconViewComponent } from '@web/widgets/shop-cart-icon/components';

// DEFAULT COMPONENT SETTINGS
const shopCartData: ShopCartIconWidgetData = {
    iconType: ECartIconType.ICON_1,
    iconBgColor: '#FFFFFF',
    iconColor: '#1D1C1C',
    iconCounterBgColor: '#FF2525',
    iconCounterColor: '#FFFFFF',
    iconRounding: 30,
    iconSize: ESize.M,
};
// END DEFAULT SETTINGS

export const shopCartIconWidgetModel: WebWidgetModel = {
    componentView: ShopCartIconViewComponent,
    componentControl: null,
    name: Widgets.SHOP_CART_ICON,
    label: 'widget_shop_cart_icon_label',
    data: shopCartData,
    permission: defaultWidgetPermission,
    params: { ...defaultWidgetParams, hidden: true, type: ['specific'] },
};
